import { ExternalLink, Sparkles } from "lucide-react";
import { timeAgo } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Card } from "@/components/Layout";

const scopeLabel = (n) => (n.scope === "local" ? n.city : n.scope === "global" ? "World" : "India");

export const NewsCard = ({ n, isNew }) => {
  const { t } = useApp();
  return (
    <Card className="ks-rise space-y-2" data-testid={`news-item-${n.news_id}`}>
      <div className="flex flex-wrap items-center gap-2 text-[11px] font-bold uppercase tracking-wide">
        {isNew && <span className="rounded-full bg-[#E05C3A] px-2 py-0.5 text-white" data-testid={`news-new-${n.news_id}`}>{t("New")}</span>}
        <span className="rounded-full bg-[#0D3B2B] px-2 py-0.5 text-white" data-testid={`news-scope-${n.news_id}`}>{t(scopeLabel(n))}</span>
        <span className={`rounded-full px-2 py-0.5 ${n.topic === "Rules & penalties" ? "bg-[#FDF0EC] text-[#E05C3A]" : "bg-[#2E9E6B]/10 text-[#2E9E6B]"}`}>{t(n.topic)}</span>
        <span className="text-[#7B968B]" data-testid={`news-time-${n.news_id}`}>{n.source} · {timeAgo(n.published_at, t)}</span>
      </div>
      <p className="font-bold leading-snug text-[#0D3B2B]">{n.title}</p>
      <p className="text-sm text-[#4A6358]">{n.summary}</p>
      {n.help && <p className="flex gap-2 rounded-xl bg-[#F4F8F5] p-2 text-xs text-[#0D3B2B]"><Sparkles className="h-4 w-4 shrink-0 text-[#E05C3A]" />{n.help}</p>}
      <a href={n.link} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-sm font-semibold text-[#2E9E6B]" data-testid={`news-link-${n.news_id}`}>{t("Read full story")}<ExternalLink className="h-3.5 w-3.5" /></a>
    </Card>
  );
};
